import React, { useState, useEffect } from 'react';
import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

const CarouselButton = ({ direction, changeSlide }) => {
  return(
    <Icon
      id="botao-controle"
      className="botao-controle"
      onClick={changeSlide}
      name={`chevron ${direction}`}
    />
  );
}

export default CarouselButton;